<template>
  <div class="col-md mstabsdetails__content">
    <div class="mstabsdetails__content--title mb-3">ORDER INFORMATION</div>
    <div v-for="(item, i) in data" :key="i">
      <div
        class="row m-0 mb-1 mstabsdetails__content--info"
        v-if="item.show"
        :class="item.class"
      >
        <div class="col-md-3 p-0">{{ item.label }}</div>
        <div class="col-md-0 px-1">:</div>
        <div v-if="item.label === 'Additional Service'">
          <b-form-checkbox
            id="checkbox-1"
            v-model="consigneeUndername"
            name="checkbox-1"
            value="true"
            unchecked-value="false"
            disabled="true"
          >
            Consignee Undername
          </b-form-checkbox>
          <b-form-checkbox
            id="checkbox-2"
            v-model="shipperUndername"
            name="checkbox-2"
            value="true"
            unchecked-value="false"
            disabled="true"
          >
            Shipper Undername
          </b-form-checkbox>
          <b-form-checkbox
            id="checkbox-3"
            v-model="warehouse"
            name="checkbox-3"
            value="true"
            unchecked-value="false"
            disabled="true"
          >
            Warehouse
          </b-form-checkbox>
        </div>
        <div v-else class="col-md p-0 blue">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixinDate from '@/mixin/getters/date-time'
import mixinShipmentDetails from '@/mixin/getters/shipment-details'

export default {
  name: 'OderInformation',
  mixins: [mixinDate, mixinShipmentDetails],
  data: () => ({
    warehouse: '',
    shipperUndername: '',
    consigneeUndername: '',
    data: [
      {
        // 0
        label: 'Shipment Date',
        show: true,
        value: ''
      },
      {
        // 1
        label: 'Shipment Service',
        show: true,
        value: ''
      },
      {
        // 2
        label: 'Origin Country',
        show: true,
        value: ''
      },
      {
        // 3
        label: 'Origin City',
        show: true,
        value: ''
      },
      {
        // 4
        label: 'Pick Up Address',
        show: true,
        value: ''
      },
      {
        // 5
        label: 'Destination Country',
        show: true,
        value: ''
      },
      {
        // 6
        label: 'Destination City',
        show: true,
        value: ''
      },
      {
        // 7
        label: 'Delivery Address',
        show: true,
        value: ''
      },
      {
        // 8
        label: 'Temperature',
        show: false,
        value: ''
      },
      {
        // 9
        label: 'Insurance',
        show: true,
        value: ''
      },
      {
        // 10
        label: 'Additional Service',
        show: true,
        value: ''
      },
      {
        // 11
        label: 'Remarks',
        show: true,
        class: 'border-bottom',
        value: ''
      }
    ]
  }),
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error',

      insuranceOption: 'insurance/insuranceList',
      isLoadingInsuranceList: 'insurance/isLoadingInsuranceList'
    }),
    getInsurace() {
      return { ...this.insuranceOption, ...this.detail }
    }
  },
  methods: {
    init() {
      this.$store.dispatch('insurance/INSURANCE_LIST')

      this.data[0].value = this.getDateDefauld(this.detail.shipmentDate)
      this.data[1].value = this.getServiceType(this.detail.shipment_service)
      // this.data[1].value = `${this.getFreightMode(this.detail.freightMode)}, ${this.getShipmentType(this.detail.freightType)} ${this.detail.freightSubType && this.detail.freightSubType !== '-' ? `(${this.detail.freightSubType})` : ''}`
      this.data[2].value = this.detail.originCountry
      this.data[3].value = this.detail.originCity

      if (
        this.detail.freightType === 'LCT' ||
        this.detail.freightType === 'BARGE'
      ) {
        this.data[4].show = true
        this.data[4].label = 'Origin Address or Jetty Coordinate Point'
        this.data[4].value = this.detail.pickup_address

        this.data[7].show = true
        this.data[7].label = 'Destination Address or Jetty Coordinate Point'
        this.data[7].value = this.detail.delivery_address
      } else {
        this.data[4].value = this.detail.pickup_address
        this.data[4].show =
          this.detail.shipment_service === 'dtd' ||
          this.detail.shipment_service === 'dtp'

        this.data[7].value = this.detail.delivery_address
        this.data[7].show =
          this.detail.shipment_service === 'dtd' ||
          this.detail.shipment_service === 'ptd'
      }

      this.data[5].value = this.detail.destinationCountry
      this.data[6].value = this.detail.destinationCity

      this.data[8].value = `${this.getReefer(this.detail.freightSummary)} C`
      this.data[8].show = this.detail.freightSubType === 'Reefer'

      this.warehouse = this.detail.warehouse
      this.consigneeUndername = this.detail.consigneeUndername ? true : false
      this.shipperUndername = this.detail.shipperUndername ? true : false
      this.data[11].value = this.detail.noteForMerchant
        ? this.detail.noteForMerchant
        : '-'
    },
    getAdditional(customsClearance, clearanceDestination, estimateStorage) {
      let additional = []
      if (customsClearance === 1) {
        additional.push('Custom Clearance (Origin)')
      }
      if (clearanceDestination === 1) {
        additional.push('Custom Clearance (Destination)')
      }
      if (estimateStorage === 1) {
        additional.push('Estimate Storage')
      }
      return additional.length > 0 ? additional.join(',\n') : '-'
    },
    getReefer(data) {
      let temperature = ''
      if (data && data !== 'null') {
        const newData = JSON.parse(data)
        temperature = newData.qty
      }
      return temperature
    },
    getCurrency(value) {
      let newValue = ''
      if (value) {
        newValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return newValue
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    detail(data) {
      if (data) {
        this.init()
      }
    },
    getInsurace() {
      if (this.detail.id_insurance === 1 || this.detail.id_insurance === 2) {
        this.insuranceOption.forEach(element => {
          if (element.id === this.detail.id_insurance) {
            this.data[9].value = element.name
          }
        })
      } else if (
        this.detail.id_insurance === 3 ||
        this.detail.id_insurance === null
      ) {
        if (
          this.detail.option_insurance === '1' ||
          this.detail.option_insurance === true
        ) {
          this.data[9].value = this.insuranceOption[0].name
        } else {
          this.data[9].value = 'None'
        }
      } else {
        this.data[9].value = 'None'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/tab-detail/OrderInformation.vue